import { observable, action, makeObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

export class MemberSummaryStore {
  memberIds: string[] = [];
  pathDetails: any[] = [];
  isStoplossPage: boolean = false;
  diseasesList: { disease: string; memberIds: string[] }[] = [];
  currentDisease: string = '';
  summaryLabel: string = '';
  careQualityMeasuresList: string[] = [];
  careQualityMeasuresMap: Map<string, string[]> = new Map<string, string[]>();
  careQualityMeasureRuleID: Map<string, string> = new Map<string, string>();
  deductibleAmount: number = 0;
  diseasesDropDownList: string[] = [];
  diseasesMembersMap: Map<string, any> = new Map<string, any>();

  constructor() {
    makeObservable(this, {
      memberIds: observable,
      setMemberIds: action,
      pathDetails: observable,
      setPathDetails: action,
      removePathDetails: action,
      isStoplossPage: observable,
      setIsStoplossPage: action,
      diseasesList: observable,
      setDiseasesList: action,
      currentDisease: observable,
      setCurrentDisease: action,
      summaryLabel: observable,
      setSummaryLabel: action,
      careQualityMeasuresList: observable,
      careQualityMeasuresMap: observable,
      careQualityMeasureRuleID: observable,
      setcareQualityMeasureRuleID: action,
      setCareQualityMeasuresList: action,
      removeCareQualityMeasuresList: action,
      setCareQualityMeasuresMap: action,
      removeCareQualityMeasuresMap: action,
      deductibleAmount: observable,
      setDeductibleAmount: action,
      diseasesDropDownList: observable,
      diseasesMembersMap: observable,
      setDiseasesDropDownList: action,
      setDiseasesMembersMap: action,
    });
    makePersistable(this, {
      name: 'MemberSummaryStore',
      properties: [
        'memberIds',
        'pathDetails',
        'isStoplossPage',
        'diseasesList',
        'currentDisease',
        'summaryLabel',
        'careQualityMeasuresList',
        'careQualityMeasuresMap',
        'careQualityMeasureRuleID',
        'deductibleAmount',
        'diseasesDropDownList',
        'diseasesMembersMap',
      ],
      storage: window.localStorage,
    });
  }

  setMemberIds(memberIds: string[]) {
    this.memberIds = memberIds;
  }

  removeMemberIds() {
    this.memberIds = [];
  }

  setPathDetails(pathDetails: any[]) {
    this.pathDetails = pathDetails;
  }

  removePathDetails() {
    this.pathDetails = [];
  }

  setIsStoplossPage(isStoplossPage: boolean) {
    this.isStoplossPage = isStoplossPage;
  }
  setDiseasesList(diseasesList: { disease: string; memberIds: string[] }[]) {
    this.diseasesList = diseasesList;
  }

  setCurrentDisease(currentDisease: string) {
    this.currentDisease = currentDisease;
  }

  setCareQualityMeasuresList(careQualityMeasuresList: string[]) {
    this.careQualityMeasuresList = careQualityMeasuresList;
  }

  removeCareQualityMeasuresList() {
    this.careQualityMeasuresList = [];
  }

  setCareQualityMeasuresMap(careQualityMeasuresMap: Map<string, string[]>) {
    this.careQualityMeasuresMap = careQualityMeasuresMap;
  }

  removeCareQualityMeasuresMap() {
    this.careQualityMeasuresMap = new Map<string, string[]>();
  }
  setcareQualityMeasureRuleID(careQualityMeasureRuleID: Map<string, string>) {
    this.careQualityMeasureRuleID = careQualityMeasureRuleID;
  }

  setDeductibleAmount(deductibleAmount: number) {
    this.deductibleAmount = deductibleAmount;
  }

  removeAllData() {
    this.memberIds = [];
    this.pathDetails = [];
    this.isStoplossPage = false;
    this.diseasesList = [];
    this.currentDisease = '';
    this.summaryLabel = '';
    this.careQualityMeasuresList = [];
    this.careQualityMeasuresMap = new Map<string, string[]>();
    this.careQualityMeasureRuleID = new Map<string, string>();
    this.deductibleAmount = 0;
    this.diseasesDropDownList = [];
    this.diseasesMembersMap = new Map<string, any>();
  }

  setSummaryLabel(summaryLabel: string) {
    this.summaryLabel = summaryLabel;
  }
  setDiseasesDropDownList(diseasesDropDownList: string[]) {
    this.diseasesDropDownList = diseasesDropDownList;
  }

  setDiseasesMembersMap(diseasesMembersMap: Map<string, any>) {
    this.diseasesMembersMap = diseasesMembersMap;
  }
}
export default MemberSummaryStore;
